export type UiLoadState = {
  paused: boolean;
  message: string;
  sinceMs: number | null;
  byLogin: string | null;
  adminExempt: boolean;
};

const DEFAULT_MESSAGE =
  "Dashboard paused due to high server load. Please try again shortly.";

let state: UiLoadState = {
  paused: false,
  message: DEFAULT_MESSAGE,
  sinceMs: null,
  byLogin: null,
  adminExempt: false,
};

const listeners = new Set<() => void>();

function emit() {
  for (const fn of listeners) fn();
}

export function getUiLoadState(): UiLoadState {
  return state;
}

export function isUiLoadReduced(): boolean {
  return state.paused && !state.adminExempt;
}

export function subscribeUiLoad(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setUiLoadFromServer(payload: {
  paused?: boolean;
  message?: string;
  sinceMs?: number | null;
  since_ms?: number | null;
  byLogin?: string | null;
  by_login?: string | null;
}) {
  state = {
    ...state,
    paused: Boolean(payload.paused),
    message: String(payload.message || DEFAULT_MESSAGE),
    sinceMs:
      payload.sinceMs ??
      payload.since_ms ??
      (payload.paused === false ? null : state.sinceMs),
    byLogin:
      payload.byLogin ??
      payload.by_login ??
      (payload.paused === false ? null : state.byLogin),
  };
  emit();
}

export function setUiLoadAdminExempt(adminExempt: boolean) {
  if (state.adminExempt === adminExempt) return;
  state = { ...state, adminExempt };
  emit();
}
